import * as React from "react";
const SvgFiRrMinusHexagon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-minus-hexagon_svg__a)">
      <path
        fill="#062147"
        d="m23.34 9.48-3.5-6A5.02 5.02 0 0 0 15.522 1H8.45a5.02 5.02 0 0 0-4.32 2.48l-3.5 6a5.01 5.01 0 0 0 0 5.039l3.5 6a5.02 5.02 0 0 0 4.319 2.48h7.07c1.772 0 3.427-.95 4.32-2.48l3.5-6a5.01 5.01 0 0 0 0-5.039m-1.728 4.031-3.5 6a3.01 3.01 0 0 1-2.591 1.488H8.45a3.01 3.01 0 0 1-2.591-1.488l-3.5-6a3 3 0 0 1 0-3.023l3.499-6A3.01 3.01 0 0 1 8.45 3h7.07a3.01 3.01 0 0 1 2.592 1.488l3.5 6a3 3 0 0 1 0 3.023M17 11.999a1 1 0 0 1-1 1H8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-minus-hexagon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMinusHexagon;
